import * as TYPES from './types'

/**
 * Default Analytics Projects State
 */
export const defaultState: TYPES.AnalyticsProjectState = {
  httpInProgress: false,
  httpError: '',
  httpSymbolicFilesStatsInProgress: false,
  httpSymbolicFilesStatsError: '',
  httpCrashGroupInProgress: false,
  httpCrashGroupError: '',
  httpCrashGroupUpdateInProgress: false,
  httpCrashGroupUpdateError: '',
  projectData: {
    projectID: '',
    editor: {
      latestUniqueUsers: [],
      geo: {},
      platformOS: {},
      platformCPU: {},
      platformGPU: {},
      platformRAM: {},
      dailyStats: [],
      crashGroups:[]
    },
    server: {
      latestUniqueUsers: [],
      geo: {},
      platformOS: {},
      platformCPU: {},
      platformGPU: {},
      platformRAM: {},
      dailyStats: [],
      crashGroups:[]
    },
    client: {
      latestUniqueUsers: [],
      geo: {},
      platformOS: {},
      platformCPU: {},
      platformGPU: {},
      platformRAM: {},
      dailyStats: [],
      crashGroups:[]
    },
    reportDownloads: [],
    crashGroupsOccurrenceSinceTimestamp: Date.now(),
    crashGroupsProcessiongReportsCount: 0,
    lastSymbolicFileUploadTimestamp: 0,
    symbolicFilesStats: []
  }
}

// define initial state object
const initialState: TYPES.AnalyticsProjectState = {
  httpInProgress: defaultState.httpInProgress,
  httpError: defaultState.httpError,
  httpSymbolicFilesStatsInProgress: defaultState.httpSymbolicFilesStatsInProgress,
  httpSymbolicFilesStatsError: defaultState.httpSymbolicFilesStatsError,
  httpCrashGroupInProgress: defaultState.httpCrashGroupInProgress,
  httpCrashGroupError: defaultState.httpCrashGroupError,
  httpCrashGroupUpdateInProgress: defaultState.httpCrashGroupUpdateInProgress,
  httpCrashGroupUpdateError: defaultState.httpCrashGroupUpdateError,
  projectData:defaultState.projectData
}

// define projects reducer
export function analyticsProjectReducer (
  state = initialState,
  action: TYPES.AnalyticsProjectActionTypes
): TYPES.AnalyticsProjectState {
  switch (action.type) {
    case TYPES.ANALYTICS_PROJECT_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: true, httpError: '' }
      }
    }
    case TYPES.ANALYTICS_PROJECT_ERROR: {
      return {
        ...state,
        ...{ httpInProgress: false, httpError: action.error }
      }
    }
    case TYPES.ANALYTICS_PROJECT_GET: {
        return {
            ...state,
            ...{ projectData: action.projectData },
            ...{ httpInProgress: false, httpError: '' }
        }
    }
    case TYPES.ANALYTICS_PROJECT_SYMBOLIC_FILES_STATS_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpSymbolicFilesStatsInProgress: true, httpSymbolicFilesStatsError: '' }
      }
    }
    case TYPES.ANALYTICS_PROJECT_SYMBOLIC_FILES_STATS_ERROR: {
      return {
        ...state,
        ...{ httpSymbolicFilesStatsInProgress: false, httpSymbolicFilesStatsError: action.error }
      }
    }
    case TYPES.ANALYTICS_PROJECT_SYMBOLIC_FILES_STATS_GET: {
        return {
            ...state,
            ...{ projectData: { ...state.projectData, symbolicFilesStats: action.symbolicFilesStats } },
            ...{ httpSymbolicFilesStatsInProgress: false, httpSymbolicFilesStatsError: '' }
        }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpCrashGroupInProgress: true, httpCrashGroupError: '' }
      }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_ERROR: {
      return {
        ...state,
        ...{ httpCrashGroupInProgress: false, httpCrashGroupError: action.error }
      }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_GET: {

        return {
            ...state,
            ...{ projectData: action.projectData },
            ...{ httpCrashGroupInProgress: false, httpCrashGroupError: '' }
        }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_UPDATE_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpCrashGroupUpdateInProgress: true, httpCrashGroupUpdateError: '' }
      }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_UPDATE_ERROR: {
      return {
        ...state,
        ...{ httpCrashGroupUpdateInProgress: false, httpCrashGroupUpdateError: action.error }
      }
    }
    case TYPES.ANALYTICS_CRASH_GROUP_UPDATE: {

        return {
            ...state,
            ...{ projectData: action.projectData },
            ...{ httpCrashGroupUpdateInProgress: false, httpCrashGroupUpdateError: '' }
        }
    }  
    default:
      return state
  }
}
